<template>
  <!-- id="newsletter": the sign-up block in posts links here (#newsletter). -->
  <SectionFrame id="newsletter" :section="section" :index="index" :heading="layout === 'inline' ? heading : ''" label="Newsletter" :narrow="true">
    <div :class="layout === 'card' ? 't-card s2-news-card' : 's2-news'" class="mo-reveal">
      <h2 v-if="layout === 'card' && heading" class="t-h3">{{ heading }}</h2>
      <p v-if="section.incentive" class="t-body">{{ section.incentive }}</p>
      <div v-if="sent" class="s2-ok" role="status"><b>Thanks, you're signed up.</b>
        <p v-if="preview" class="s2-note">This is the studio preview: nothing was saved.</p></div>
      <form v-else @submit.prevent="submit" novalidate>
        <div class="s2-news-row">
          <label class="s2-hp" :for="`${uid}-e`">Your email</label>
          <input :id="`${uid}-e`" v-model="email" type="email" autocomplete="email" class="s2-input" placeholder="Your email" required>
          <button type="submit" class="t-btn" :disabled="sending">{{ sending ? "Signing up…" : "Sign up" }}</button>
        </div>
        <label class="s2-consent">
          <input v-model="consent" type="checkbox" required>
          <span>{{ consentText }}</span>
        </label>
        <div class="s2-hp" aria-hidden="true"><label>Business name<input v-model="honeypot" tabindex="-1" autocomplete="off"></label></div>
        <p v-if="problem || error" class="s2-err" role="alert">{{ problem || error }}</p>
      </form>
    </div>
  </SectionFrame>
</template>

<script setup>
import {computed, ref} from "vue";
import SectionFrame from "./SectionFrame.vue";
import {layoutOf} from "@/utils/sectionLogic.js";
import {useFormPost} from "./useFormPost.js";

const props = defineProps({section: {type: Object, required: true}, index: {type: Number, default: 0}});
const layout = computed(() => layoutOf(props.section, ["inline", "card"]));
const heading = computed(() => props.section.heading ?? "Get our news");
const consentText = computed(() => props.section.consentText || "Yes, email me now and then. I can unsubscribe at any time.");
const email = ref("");
const consent = ref(false);
const problem = ref("");
const uid = `n${String(props.section.id || "").replace(/[^a-z0-9]/gi, "").slice(0, 8)}`;
const {honeypot, sending, sent, error, preview, post} = useFormPost();

async function submit() {
  problem.value = "";
  if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.value.trim())) { problem.value = "Please enter your email address."; return; }
  if (!consent.value) { problem.value = "Please tick the box to say we can email you."; return; }
  // The exact words they agreed to are kept with their sign-up.
  await post("newsletter", {email: email.value.trim(), consent: true, consentText: consentText.value, source: "website"});
}
</script>

<style>
.s2-news-row { display: flex; gap: .5rem; }
.s2-news-row .s2-input { flex: 1; }
@media (max-width: 480px) { .s2-news-row { flex-direction: column; } }
.s2-consent { display: flex; gap: .6rem; align-items: flex-start; margin-top: .8rem; font-size: .9rem; cursor: pointer; }
.s2-consent input { width: 1.15rem; height: 1.15rem; margin-top: .15rem; accent-color: var(--t-accent); flex: none; }
.s2-news-card { max-width: 640px; margin: 0 auto; }
</style>
